import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpHeaders,HttpParams } from '@angular/common/http';
import { BehaviorSubject,Observable, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})

export class MngDataTransSapService {

  
  searchdropdownUrlApi = this.environment.MastersearchdropdownapiUrl;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

 namc = 'getNamc/{proxy+}'
 ebomToSAPTransmissionType = 'getEbomToSAPTransmissionType/{proxy+}'
 gridData = '/getMngDataTrnsfrGrid/{proxy+}'
 
  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  //namc
  getNAMC(): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = `${this.searchdropdownUrlApi}/${this.namc}`+'?screenNo=NBPC_9997'+'&fileName=' +fileName;
    return this.http.get(API_URL,httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  //grid data
  getMngDataTrnsfrGrid(gridData): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams= new HttpParams().set('namcLglEntityId',gridData.namc)
    //                                 .append('transTyp',gridData.ebomToSAPTransmissionType)
    //                                 .append('strtDtTime',gridData.sendToSAPStartDate)
    //                                 .append('endDtTime',gridData.sendToSAPEndDate)
    //                                 .append('comments',gridData.comments)
    //                                 .append('option',gridData.option)
                                    
    let API_URL = this.environment.MastergridapiUrl + this.gridData + '?namcLglEntityId=' + gridData.namc
    + '&transTyp=' + gridData.ebomToSAPTransmissionType + '&strtDtTime=' + gridData.sendToSAPStartDate
    + '&endDtTime=' + gridData.sendToSAPEndDate + '&comments=' + gridData.comments+'&screenNo=NBPC_9997'+'&fileName=' +fileName
    + '&option=' + gridData.option ;
    return this.http.get(API_URL,httpOptions)
      .pipe(catchError(this.error)
      )
  }


  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage:any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}
